import actionTypes from '../constants/action-types.js';

const dropTargetElement = (state = null, action) => {
  if (action.type !== actionTypes.SET_TARGET_ELEMENT) return state;
  return action.payload.elementId;
};

export default dropTargetElement;
